import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

export const StyledLink = styled(Link)<{ height: string; width: string }>(({ theme, height, width }) => ({
  textDecoration: 'none',
  color: theme.palette.text.primary,
  height,
  width,
}));
